import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaChevronDown, FaSignOutAlt, FaUser } from "react-icons/fa";
import { HiMiniBars3CenterLeft } from "react-icons/hi2";
import imgIcon from "../assets/images/userIcon.png";
import { useAuth } from "../Context/AuthContext";

const Topbar = () => {
  const navigate = useNavigate();
  const { logout,user } = useAuth(); // ✅ Using AuthContext logout

  const [userRole, setUserRole] = useState(null);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [dailyTimecard, setDailyTimecard] = useState("N");
  const [ticketTimecard, setTicketTimecard] = useState("N");
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [userDetails, setUserDetails] = useState(null);

  const username = localStorage.getItem("username");

  const toggleUserDropdown = () => {
    setShowUserDropdown((prev) => !prev);
  };

  // Load user details once from localStorage
  useEffect(() => {
    try {
      const storedUser = JSON.parse(localStorage.getItem("userDetails"));
      if (storedUser) {
        setUserDetails(storedUser);
        setUserRole(storedUser?.role || "N/A");
        setDailyTimecard(storedUser?.dailyTimecard || "N");
        setTicketTimecard(storedUser?.ticketTimecard || "N");
      }
    } catch (error) {
      console.error("Failed to parse user data from localStorage", error);
    }
  }, []);

  // ✅ Use logout from AuthContext instead of re-implementing it
  const handleLogout = () => {
    setShowUserDropdown(false);
    logout(); // This will clear localStorage, setUser(null), and navigate to /login
  };

  const handleProfileButton = () => {
    setShowUserDropdown(false);
    navigate("/profile-page");
  };

  const handleToggleSideBar = () => {
    document.body.classList.toggle("toggle-sidebar");
  };

  return (
    <>
      <div className="dashboard-header">
        <div className="header-left">
          <button className="menu-button" onClick={handleToggleSideBar} >
            <HiMiniBars3CenterLeft className="bar-icon" />
          </button>
        </div>

        <div className="header-center">
          <h2 className="dashboard-title" onClick={()=>navigate('/home')} style={{cursor:"pointer"}}>MAVRO</h2>
        </div>

        <div className="header-right">
          {username && (
            <div className="user-dropdown-container">
              <button className="user-button" onClick={toggleUserDropdown}>
                <img src={imgIcon} alt="user" className="img-fluid user-icon" />
                <span className="username">{username}</span>
                <FaChevronDown className="down-icon" />
              </button>

              {showUserDropdown && (
                <div className="user-dropdown">
                  <div className="user-role">
                    <p>Name:&nbsp;{username}</p>
                    <p>Role:&nbsp;{user.roles.join(", ")}</p>
                  </div>
                  <button
                    className="profile-dropdown-button"
                    onClick={handleProfileButton}
                  >
                    <FaUser /> View Profile
                  </button>

                  <button
                    className="logout-dropdown-button"
                    onClick={handleLogout}
                  >
                    <FaSignOutAlt /> Logout
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Profile Modal */}
      {showProfileModal && userDetails && (
        <div
          className="modal-overlay"
          onClick={() => setShowProfileModal(false)}
        >
          <div
            className="profile-modal"
            onClick={(e) => e.stopPropagation()} // prevent closing on modal click
          >
            <button
              className="modal-close-icon"
              onClick={() => setShowProfileModal(false)}
            >
              &times;
            </button>
            <h2>User Profile</h2>
            <div className="profile-details">
              <p><strong>User ID:</strong> {userDetails.userId}</p>
              <p><strong>Organisation ID:</strong> {userDetails.organisationId}</p>
              <p>
                <strong>Username:</strong>{" "}
                {userDetails.username
                  ? userDetails.username.charAt(0).toUpperCase() +
                    userDetails.username.slice(1)
                  : ""}
              </p>
              <p><strong>Email:</strong> {userDetails.email}</p>
              <p><strong>Role:</strong> {userDetails.role}</p>
              <p>
                <strong>Daily Timecard:</strong>{" "}
                {userDetails.dailyTimecard === "Y" ? "Yes" : "No"}
              </p>
              <p>
                <strong>Ticket Timecard:</strong>{" "}
                {userDetails.ticketTimecard === "Y" ? "Yes" : "No"}
              </p>
              {userDetails.roles && (
                <p>
                  <strong>All Roles:</strong> {userDetails.roles.join(", ")}
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Topbar;
